export interface GnssDevice {
  id: string;
  brand: string;
  model: string;
  img: string;
  type: string;
}

export const GNSS_DEVICES: GnssDevice[] = [
  { id: "south-g9",   brand: "South",     model: "Galaxy G9", img: "/assets/gps/south-galaxy-g9.jpg",  type: "Rover/Base" },
  { id: "hi-v200",    brand: "Hi-Target", model: "V200",      img: "/assets/gps/hi-target-v200.avif",  type: "Rover" },
  { id: "hi-u300",    brand: "Hi-Target", model: "U300",      img: "/assets/gps/hi-target-u300.avif",  type: "Rover/Base" },
  { id: "stonex-s5",  brand: "Stonex",    model: "S5",        img: "/assets/gps/stonex-s5.jpg",        type: "Rover" },
  { id: "emlid-rs2",  brand: "Emlid",     model: "Reach RS2", img: "/assets/gps/emlid-reach-rs2.png",  type: "Rover/Base" },
  { id: "chcnav-i73", brand: "CHCNAV",    model: "i73",       img: "/assets/gps/chcnav-i73.png",       type: "Rover" },
];
